/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shy_Plum_Snake_GazeInputs */

const en_shy_plum_snake_gaze = /** @type {(inputs: Shy_Plum_Snake_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactive`)
};

const de_shy_plum_snake_gaze = /** @type {(inputs: Shy_Plum_Snake_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inaktiv`)
};

/**
* | output |
* | --- |
* | "Inactive" |
*
* @param {Shy_Plum_Snake_GazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shy_plum_snake_gaze = /** @type {((inputs?: Shy_Plum_Snake_GazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shy_Plum_Snake_GazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shy_plum_snake_gaze(inputs)
	return de_shy_plum_snake_gaze(inputs)
});